/**
 * WordPress Command Palette Integration for Ultimate Addons for Elementor
 *
 * Registers navigation commands for quick access to UAEL settings and features
 * via the WordPress Command Palette (Ctrl/Cmd + K)
 *
 * Supports white-label branding - command labels and URLs adapt to your branding settings
 *
 * @package UAEL
 * @since x.x.x
 */

import { store as commandsStore } from '@wordpress/commands';
import { dispatch, select } from '@wordpress/data';
import { __ } from '@wordpress/i18n';

/**
 * Register UAEL navigation commands with the WordPress Command Palette
 *
 * These commands allow users to quickly navigate to UAEL admin pages
 * from anywhere in the WordPress admin dashboard.
 */

// Prevent duplicate registration - exit if commands are already registered
if ( ! window.uaelCommandsRegistered ) {
	window.uaelCommandsRegistered = true;

	// Get branding data from localized script
	const branding = window.uaelCommandPalette || {};
	const pluginShortName = branding.pluginShortName || 'Ultimate Addons';
	const pluginName = branding.pluginName || 'Ultimate Addons for Elementor';

	// Command 1: Navigate to UAEL Dashboard
	dispatch( commandsStore ).registerCommand( {
		name: 'uael/goto-uael-dashboard',
		label: __( 'Go to: ', 'uael' ) + pluginShortName,
		searchLabel: pluginShortName + ' ' + pluginName + ' ' + __( 'Dashboard Settings Elementor', 'uael' ),
		callback: ( { close } ) => {
			document.location.href = branding.adminUrl + 'admin.php?page=uaepro';
			close();
		}
	} );

	// Command 2: Navigate to UAEL Widgets
	dispatch( commandsStore ).registerCommand( {
		name: 'uael/goto-uael-widgets',
		label: __( 'Go to: ', 'uael' ) + pluginShortName + __( ' > Widgets', 'uael' ),
		searchLabel: pluginShortName + ' ' + pluginName + ' ' + __( 'Widgets Elements Enable Disable', 'uael' ),
		callback: ( { close } ) => {
			document.location.href = branding.adminUrl + 'admin.php?page=uaepro#widgets';
			close();
		}
	} );

	// Command 3: Navigate to UAEL Settings (Integrations Tab)
	dispatch( commandsStore ).registerCommand( {
		name: 'uael/goto-uael-integrations',
		label: __( 'Go to: ', 'uael' ) + pluginShortName + __( ' > Integrations', 'uael' ),
		searchLabel: pluginShortName + ' ' + pluginName + ' ' + __( 'Integrations API Settings Google Facebook Recaptcha', 'uael' ),
		callback: ( { close } ) => {
			document.location.href = branding.adminUrl + 'admin.php?page=uaepro#settings';
			close();
		}
	} );

	// Command 5: Navigate to Knowledge Base (only if enabled in branding)
	if ( branding.enableKb === 'enable' && branding.kbUrl ) {
		dispatch( commandsStore ).registerCommand( {
			name: 'uael/goto-knowledge-base',
			label: __( 'Go to: ', 'uael' ) + pluginShortName + __( ' > Knowledge Base', 'uael' ),
			searchLabel: pluginShortName + ' ' + pluginName + ' ' + __( 'Help Documentation Docs Knowledge Base', 'uael' ),
			callback: ( { close } ) => {
				window.open( branding.kbUrl, '_blank' );
				close();
			}
		} );
	}

	// Command 6: Navigate to Support (only if enabled in branding)
	if ( branding.enableSupport === 'enable' && branding.supportUrl ) {
		dispatch( commandsStore ).registerCommand( {
			name: 'uael/goto-support',
			label: __( 'Go to: ', 'uael' ) + pluginShortName + __( ' > Support', 'uael' ),
			searchLabel: pluginShortName + ' ' + pluginName + ' ' + __( 'Support Help Ticket Contact', 'uael' ),
			callback: ( { close } ) => {
				window.open( branding.supportUrl, '_blank' );
				close();
			}
		} );
	}
}
